var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowDownload),expression:"isShowDownload"}],staticClass:"flex flex-center let-download",on:{"click":_vm.handleClick}},[_c('Icon',{attrs:{"path":"preview","name":"download"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }